








import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import { MediaFilesController } from "@/lib/MediaFilesController";

export default defineComponent({
  name: "ProfileHeaderBackground",
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup(props) {
    const { showNotSafeForWork } = useNSFWUserSettings();
    const src = computed(() => {
      let bg: FileData | null;
      if (!props.user || (!props.user.background && !props.user.backgroundNsfw)) {
        bg = null;
      } else if (showNotSafeForWork.value) {
        bg = props.user.backgroundNsfw ? props.user.backgroundNsfw : props.user.background ?? null;
      } else {
        bg = props.user.background ? props.user.background : props.user.backgroundNsfw ?? null;
      }
      return bg ? MediaFilesController.getImageThumbnail(bg.urlPart, "1080p") : "";
    });

    const blurred = computed(
      () => !!props.user && !showNotSafeForWork.value && !props.user.background && props.user.backgroundNsfw
    );
    return {
      src,
      blurred,
    };
  },
});
